<template>
  <div>
    <div class="text-right">
      <el-button type="primary" size="mini" @click="dialogVisible = true">
        Create Newsletter
      </el-button>
    </div>
    <el-dialog title="Create Newsletter" :visible.sync="dialogVisible">
      <p>Start by drafting your newsletter subject line and message body. After saving, you must test the newsletter at least once before it can be scheduled for dispatching.</p>
      <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
        <el-form-item label="Subject" prop="title">
          <el-input v-model="form.title" type="text" />
        </el-form-item>
        <el-form-item label="Content" prop="content">
          <el-input v-model="form.content" type="textarea" />
        </el-form-item>
        <el-button native-type="submit" type="primary" :loading="loading">
          Save
        </el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        title: '',
        content: '',
      },
      rules: {
        'title': [
          { required: true, message: 'Enter the subject of the newsletter.', trigger: 'blur' },
        ],
        'content': [
          { required: true, message: 'Enter the content of the newsletter.', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) return false

        this.loading = true

        try {
          var { data } = await this.$http.post(`/newsletters`, this.form)
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$message.success('Newsletter has been saved.')
        this.$router.push({ name: 'newsletters-id', params: { id: data.newsletter.id } })
      })
    },
  },
}
</script>
